import http from "@/utils/http";
import { ICOSConfig } from "./components/FormUpload/type";

/**
 * 获取COS配置信息，包含一下字段信息：
 * region：域
 * bucket：存储桶
 * session_token：临时token
 * temp_secret_id：临时公钥id
 * temp_secret_key：临时公钥key
 * @param payload 获取COS配置信息的入参
 * @returns COS配置信息
 */
export const getCOSConfig = (): Promise<ICOSConfig> => {
  return http({
    url: '/api/v1/aitools/tencent_qcloud/auth',
    method: 'get',
  }) as Promise<ICOSConfig>;
};

export const uploadSubmit = (params: object): Promise<any> => {
  return http({
    url: '/api/v1/aitools/create',
    method: 'post',
    errorHandler: true,
    data: params,
  }) as Promise<any>;
};